import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NProfiles } from '../profile.interfaces';

/**
 * Resolver to load CMS block for the horse edit page
 */
export const horseEditResolver: ResolveFn<NProfiles.IHorseEditContent | undefined> = async () => {
    const iCmsBlockResource = inject(ICmsBlockResource);
    const block = await iCmsBlockResource.retrieve<NProfiles.IHorseEditContent>({ bareUrl: NProfiles.COMPONENT_IDS.horseEdit }, undefined);
    return block && block instanceof Object ? (block.data?.content as NProfiles.IHorseEditContent) : undefined;
};
